import { Route } from "react-router-dom";

import {
  CREATE_PURCHASE,
  EDIT_PURCHASE,
  RETURN_PURCHASE,
  VIEW_VENDOR,
  VIEW_VENDOR_STATEMENT,
} from "src/constants";
import { VENDOR_ROUTES } from "src/pages/vendor/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AddEditPurchase } from "./AddEditPurchase.page";
import { PurchaseInvoice } from "./PurchaseInvoice.page";
import { PurchaseReturnInvoice } from "./PurchaseReturnInvoice";
import { ReturnPurchase } from "./ReturnPurchase.page";
import { SingleVendor } from "./SingleVendor.page";
import { VendorReceipt } from "./VendorReceipt.page";
import { Vendors } from "./Vendors.page";

/** Route tree for the vendor module, mounted under `/vendors` and `/vendor`. */
export const vendorRoutes = (
  <>
    <Route path={VENDOR_ROUTES.root} element={<ProtectedRoute permissions={VIEW_VENDOR} component={Vendors} />} />
    <Route path={VENDOR_ROUTES.details} element={<ProtectedRoute permissions={VIEW_VENDOR} component={SingleVendor} />} />
    <Route
      path={VENDOR_ROUTES.addPurchase}
      element={<ProtectedRoute permissions={CREATE_PURCHASE} component={AddEditPurchase} />}
    />
    <Route
      path={VENDOR_ROUTES.editPurchase}
      element={<ProtectedRoute permissions={EDIT_PURCHASE} component={AddEditPurchase} />}
    />
    <Route
      path={VENDOR_ROUTES.invoice}
      element={<ProtectedRoute permissions={VIEW_VENDOR_STATEMENT} component={PurchaseInvoice} />}
    />
    <Route
      path={VENDOR_ROUTES.invoiceReturn}
      element={<ProtectedRoute permissions={RETURN_PURCHASE} component={ReturnPurchase} />}
    />
    <Route
      path={VENDOR_ROUTES.return}
      element={<ProtectedRoute permissions={RETURN_PURCHASE} component={PurchaseReturnInvoice} />}
    />
    <Route
      path={VENDOR_ROUTES.payment}
      element={<ProtectedRoute permissions={VIEW_VENDOR_STATEMENT} component={VendorReceipt} />}
    />
  </>
);
